<template>
	<v-card flat class="elevation-0 terms-page">
		<v-card-title class="terms-page__title mt-16 mb-16">Terms & Privacy</v-card-title>
		<v-card-subtitle class="terms-page__subtitle mb-5">Terms & Privacy page</v-card-subtitle>
		<v-card-text class="terms-page__content">
			<p>
				The idea to construct a Masonic memorial for George Washington was first proposed in
				1852 by the Washington area's "mother lodge," Fredericksburg Lodge No. 4 (located in
				Fredericksburg, Virginia).[17] Funds were sought from Grand Lodges (state-level
				Masonic organizations) throughout the United States to construct a memorial Masonic
				Temple with a large statue in the vestibule.[18] Enough funds were raised to
				commission a life-size bronze statue of Washington in full Masonic regalia from the
				famous sculptor, Hiram Powers who was living in Rome, Italy.[19] The statue reached
				Alexandria in early 1861, just before the outbreak of the American Civil War.[19] It
				remained on display in Alexandria until the summer of 1863, when it was moved to
				Richmond, Virginia.[19] The statue was destroyed in the fire which occurred as
				Richmond surrendered to the Army of the Potomac on April 3, 1865.[19]
			</p>
			<p>
				The idea to construct a Masonic memorial for George Washington was first proposed in
				1852 by the Washington area's "mother lodge," Fredericksburg Lodge No. 4 (located in
				Fredericksburg, Virginia).[17] Funds were sought from Grand Lodges (state-level
				Masonic organizations) throughout the United States to construct a memorial Masonic
				Temple with a large statue in the vestibule.[18] Enough funds were raised to
				commission a life-size bronze statue of Washington in full Masonic regalia from the
				famous sculptor, Hiram Powers who was living in Rome, Italy.[19] The statue reached
				Alexandria in early 1861, just before the outbreak of the American Civil War.[19] It
				remained on display in Alexandria until the summer of 1863, when it was moved to
				Richmond, Virginia.[19] The statue was destroyed in the fire which occurred as
				Richmond surrendered to the Army of the Potomac on April 3, 1865.[19] The idea to
				construct a Masonic memorial for George Washington was first proposed in 1852 by the
				Washington area's "mother lodge," Fredericksburg Lodge No. 4 (located in
				Fredericksburg, Virginia).[17] Funds were sought from Grand Lodges (state-level
				Masonic organizations) throughout the United States to construct a memorial Masonic
				Temple with a large statue in the vestibule.[18] Enough funds were raised to
				commission a life-size bronze statue of Washington in full Masonic regalia from the
				famous sculptor, Hiram Powers who was living in Rome, Italy.[19] The statue reached
				Alexandria in early 1861, just before the outbreak of the American Civil War.[19] It
				remained on display in Alexandria until the summer of 1863, when it was moved to
				Richmond, Virginia.[19] The statue was destroyed in the fire which occurred as
				Richmond surrendered to the Army of the Potomac on April 3, 1865.[19]
			</p>
		</v-card-text>
		<v-card-subtitle class="terms-page__subtitle mb-5">Terms & Privacy page</v-card-subtitle>
		<v-card-text class="terms-page__content">
			<p>
				The idea to construct a Masonic memorial for George Washington was first proposed in
				1852 by the Washington area's "mother lodge," Fredericksburg Lodge No. 4 (located in
				Fredericksburg, Virginia).[17] Funds were sought from Grand Lodges (state-level
				Masonic organizations) throughout the United States to construct a memorial Masonic
				Temple with a large statue in the vestibule.[18] Enough funds were raised to
				commission a life-size bronze statue of Washington in full Masonic regalia from the
				famous sculptor, Hiram Powers who was living in Rome, Italy.[19] The statue reached
				Alexandria in early 1861, just before the outbreak of the American Civil War.[19] It
				remained on display in Alexandria until the summer of 1863, when it was moved to
				Richmond, Virginia.[19] The statue was destroyed in the fire which occurred as
				Richmond surrendered to the Army of the Potomac on April 3, 1865.[19]
			</p>
			<p>
				The idea to construct a Masonic memorial for George Washington was first proposed in
				1852 by the Washington area's "mother lodge," Fredericksburg Lodge No. 4 (located in
				Fredericksburg, Virginia).[17] Funds were sought from Grand Lodges (state-level
				Masonic organizations) throughout the United States to construct a memorial Masonic
				Temple with a large statue in the vestibule.[18] Enough funds were raised to
				commission a life-size bronze statue of Washington in full Masonic regalia from the
				famous sculptor, Hiram Powers who was living in Rome, Italy.[19] The statue reached
				Alexandria in early 1861, just before the outbreak of the American Civil War.[19] It
				remained on display in Alexandria until the summer of 1863, when it was moved to
				Richmond, Virginia.[19] The statue was destroyed in the fire which occurred as
				Richmond surrendered to the Army of the Potomac on April 3, 1865.[19] The idea to
				construct a Masonic memorial for George Washington was first proposed in 1852 by the
				Washington area's "mother lodge," Fredericksburg Lodge No. 4 (located in
				Fredericksburg, Virginia).[17] Funds were sought from Grand Lodges (state-level
				Masonic organizations) throughout the United States to construct a memorial Masonic
				Temple with a large statue in the vestibule.[18] Enough funds were raised to
				commission a life-size bronze statue of Washington in full Masonic regalia from the
				famous sculptor, Hiram Powers who was living in Rome, Italy.[19] The statue reached
				Alexandria in early 1861, just before the outbreak of the American Civil War.[19] It
				remained on display in Alexandria until the summer of 1863, when it was moved to
				Richmond, Virginia.[19] The statue was destroyed in the fire which occurred as
				Richmond surrendered to the Army of the Potomac on April 3, 1865.[19]
			</p>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'TermsPage',
}
</script>

<style lang="scss">
.terms-page {
	&__title {
		font-family: Merriweather, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
	}

	&__subtitle {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 600;
		font-size: 20px;
		line-height: 20px;
		color: #1c1939 !important;
	}

	&__content {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 15px;
		line-height: 26px;
		letter-spacing: 0.4px;
		color: #000000;
	}
}
</style>
